import { jsx as _jsx } from "react/jsx-runtime";
import { OptionGrantDetails } from './OptionGrant';
import { Body } from '../../root/PageRouter';
import { Card } from '../../common/card';
export default function CanceledOptionGrant(props) {
    return (_jsx(Body, { children: _jsx(Card, { children: _jsx(OptionGrantDetails, { optionGrant: props.optionGrant }, void 0) }, void 0) }, void 0));
}
//# sourceMappingURL=CanceledOptionGrant.js.map